import { render } from "./MyHistory.vue?vue&type=template&id=71172834"
import script from "./MyHistory.vue?vue&type=script&lang=js"
export * from "./MyHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__